import { render, staticRenderFns } from "./McpConnectionsList.vue?vue&type=template&id=57d5689b&"
import script from "./McpConnectionsList.vue?vue&type=script&lang=js&"
export * from "./McpConnectionsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports